import Styleguide from "@store/Framework/Types/Styleguide";

const tokenExFrame: Styleguide["tokenExFrame"] = {};

export default tokenExFrame;
